module.exports = __webpack_public_path__ + "static/media/38-8.7f0cd7d4.mp3";